import styled from "styled-components";
import { H500, H700, T300 } from "../Styles";
import PiggyBank from "../UI/Icons/PiggyBank";
import HandHeart from "../UI/Icons/HandHeart";
import FastForwardCircle from "../UI/Icons/FastForwardCircle";
import I18n from "i18n-js";

type RewardCardProps = {
  icon: JSX.Element;
  title: string;
  description: string;
}

const CashRewardWrapper = styled.div`
  padding: 104px 120px;

  ${({theme}) => theme.tablet`
    padding: 64px 24px; 
  `}
`;

const CashRewardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
`;

const MainTitle = styled(H700)`
  font-family: Sentient;
`;

const CardContainer = styled.div`
  display: flex;
  gap: 32px;

  ${({theme}) => theme.tablet`
    flex-direction: column; 
    gap: 8px;
  `}
`;

const RewardCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  padding: 40px;
  border-radius: 16px;
  border: 1px solid #0c222d17;
  box-shadow: 
    0 0.5px 0.25px 0 #0c222d17, 
    0 0 16px 0 #16163708, 
    0 0 1px 0 #0a1b294a inset;

  ${({theme}) => theme.tablet`
    padding: 32px;
  `}
`;

const RewardIconContainer = styled.div`
  width: 40px;
  height: 40px;
  fill: #785827;
  margin-bottom: 8px;
`;

const RewardTitle = styled(H500)`
  font-family: Sentient;
  color: #111415;
`;

const RewardDescription = styled(T300)`
  color: #363D42;
`;

const DividerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 0;

  ${({theme}) => theme.tablet`
    flex-direction: row; 
  `}
`;

const DividerLine = styled.div`
  width: 1px;
  flex: 1;
  background-color: #0c222d17; 
  min-height: 20px;

  ${({theme}) => theme.tablet`
    min-height: 1px;
    min-width: 20px;
  `}
`;

const DividerText = styled(T300)`
  padding: 16px 0;
  color: #6F787F;
`;

const RewardCard = ({
  icon,
  title,
  description,
}: RewardCardProps) => {
  return (
    <RewardCardContent>
      <RewardIconContainer>{icon}</RewardIconContainer>
      <RewardTitle>{title}</RewardTitle>
      <RewardDescription>{description}</RewardDescription>
    </RewardCardContent>
  )
};

const Divider = () => {
  return (
    <DividerWrapper>
      <DividerLine></DividerLine>
      <DividerText>or</DividerText>
      <DividerLine></DividerLine>
    </DividerWrapper>
  )
}

const CashRewardOptions = () => {
  const rewardsOptions = [
    {
      icon: <PiggyBank size={40}/>,
      title: I18n.t("views.static_pages.hotel_landing.cash_reward_options.section_1.title"),
      description:I18n.t("views.static_pages.hotel_landing.cash_reward_options.section_1.description"),
    },
    {
      icon: <HandHeart />,
      title: I18n.t("views.static_pages.hotel_landing.cash_reward_options.section_2.title"),
      description:I18n.t("views.static_pages.hotel_landing.cash_reward_options.section_2.description"),
    },
    {
      icon: <FastForwardCircle />,
      title: I18n.t("views.static_pages.hotel_landing.cash_reward_options.section_3.title"),
      description:I18n.t("views.static_pages.hotel_landing.cash_reward_options.section_3.description"),
    },
  ]

  return (
    <CashRewardWrapper>
      <CashRewardContent>
        <HeaderWrapper>
          <T300 isStrong={true}>
            {I18n.t("views.static_pages.hotel_landing.cash_reward_options.top_header")}
          </T300>
          <MainTitle>
            {I18n.t("views.static_pages.hotel_landing.cash_reward_options.header")}
          </MainTitle>
        </HeaderWrapper>
        <CardContainer>
          <RewardCard
            icon={rewardsOptions[0].icon}
            title={rewardsOptions[0].title}
            description={rewardsOptions[0].description}
          />
          <Divider />
          <RewardCard
            icon={rewardsOptions[1].icon}
            title={rewardsOptions[1].title}
            description={rewardsOptions[1].description}
          />
          <Divider />
          <RewardCard
            icon={rewardsOptions[2].icon}
            title={rewardsOptions[2].title}
            description={rewardsOptions[2].description}
          />
        </CardContainer>
      </CashRewardContent>
    </CashRewardWrapper>
  )
}

export default CashRewardOptions;